import React from "react";
import {
    Card,
    Typography,
    Grid,
    Box,
    Chip,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { cleanName } from "../../../../../Setup/Config/formats";
import { getIcon } from "../../../../../Setup/Utils/iconHelper";

const BlurbCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(3),
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    position: 'relative',
    backgroundColor: theme.palette.info.main,
    border: `1px solid ${theme.palette.info.main}`,
    '&:hover': {
        transform: 'translateY(-4px)',
        boxShadow: 4
    }
}));

export const DepartmentList = ({ isLoading }) => {
    
    const theme = useTheme();
    const navigate = useNavigate();
    const items = useSelector((store) => store.departments.list);
    
    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" p={4}>
                <Typography>Loading departments...</Typography>
            </Box>
        );
    }

    if (!items || items.length === 0) {
        return (
            <Box display="flex" justifyContent="center" p={4}>
                <Typography>No departments found</Typography>
            </Box>
        );
    }

    return (
        <Grid container spacing={3}>
            {items.map((department) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={department.id}>
                    <DepartmentCard 
                        department={department} 
                        theme={theme}
                        navigate={navigate}
                    />
                </Grid>
            ))}
        </Grid>
    );
};

const DepartmentCard = ({ department, theme, navigate }) => {

    const handleCardClick = () => {
        navigate('/departments/' + department.id);
    };
    
    // Get dynamic icon
    const IconComponent = getIcon(department.icon, 'outlined');

    return (
        <BlurbCard onClick={handleCardClick}>
            
            {/* Department Name with Icon */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 0 }}>
                <IconComponent 
                    sx={{ 
                        fontSize: 34, 
                        color: 'white'
                    }} 
                />
                <Box>
                    <Typography 
                        variant="h6" 
                        component="h3"
                        sx={{ 
                            fontWeight: 'bold',
                            color: 'white',
                            flex: 1,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        {cleanName(department.department_name)} [{department.users_count || 0}]
                    </Typography>

                    {/* Manager Name */}
                    <Typography 
                        variant="body2" 
                        color="white"
                        sx={{ 
                            fontWeight: 'medium',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        {department.manager ? 
                            `${department.manager.first_name || ''} ${department.manager.last_name || ''}`.trim() || 'No Manager Assigned'
                            : 'No Manager Assigned'
                        }
                    </Typography>
                </Box>
            </Box>

            

            {/* Parking Chip - Top Right Corner */}
            {department.is_parking && (
                <Chip 
                    label="Parking" 
                    size="small" 
                    color="warning"
                    sx={{ 
                        position: 'absolute',
                        top: 8,
                        right: 8
                    }}
                />
            )}
        </BlurbCard>
    );
};